// Zipchat — shadow DOM style overrides

document.addEventListener('DOMContentLoaded', () => {
  let applied = false;

  const applyStyles = () => {
    if (applied) return true;

    const host = document.querySelector('#zipchat-shadow-host');
    if (!host || !host.shadowRoot) return false;

    // Flag the host so shadow-scoped selectors can react to the
    // light-DOM body class without crossing the shadow boundary.
    if (document.body.classList.contains('product-template')) {
      host.setAttribute('data-product', '');
    }

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      @media screen and (max-width: 767px) {
        #widget-chat-container {
          left: unset !important;
          transform: none !important;
          bottom: 20px !important;
          right: 15px !important;
        }

        div#type-bar {
          padding-block: 8px !important;
        }

        :host([data-product]) #widget-chat-container {
          bottom: 70px !important;
          right: 0px !important;
        }
      }

      @media screen and (min-width: 768px) {
        input#type-bar-input {
          max-width: 149px !important;
        }

        div#type-bar-wrapper {
          max-width: 250px !important;
        }

        div#type-bar {
          padding-block: 8px !important;
        }
      }

      /* Hide while scrolling down */
      :host([data-scrolled]) #widget-chat-container {
        display: none !important;
      }
    `);

    host.shadowRoot.adoptedStyleSheets = [
      ...host.shadowRoot.adoptedStyleSheets,
      sheet
    ];

    // Toggle the scroll flag on the host based on scroll direction.
    let lastScroll = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const current = window.scrollY;
        if (current > lastScroll && current > 100) {
          host.setAttribute('data-scrolled', ''); // scrolling down
        } else if (current < lastScroll) {
          host.removeAttribute('data-scrolled');   // scrolling up
        }
        lastScroll = current;
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    applied = true;
    return true;
  };

  // Apply immediately if the widget is already mounted...
  if (applyStyles()) return;

  // ...otherwise wait for it to appear.
  const observer = new MutationObserver(() => {
    if (applyStyles()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


// Hide .reset23947hdfjue8934 img on scroll down, show on scroll up
document.addEventListener('DOMContentLoaded', () => {
  let bound = false;

  const bindScroll = () => {
    const el = document.querySelector('.reset23947hdfjue8934 img');
    if (!el) return false;

    let lastScroll = window.scrollY;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const current = window.scrollY;
        if (current > lastScroll && current > 100) {
          el.classList.add('hide-on-scroll');
        } else if (current < lastScroll) {
          el.classList.remove('hide-on-scroll');
        }
        lastScroll = current;
        ticking = false;
      });
    }, { passive: true });

    bound = true;
    return true;
  };

  if (bindScroll()) return;

  const observer = new MutationObserver(() => {
    if (bindScroll()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


// ZIPCHAT TEXT CHANGE

document.addEventListener("DOMContentLoaded", () => {
  const texts = ["Beauty Advisor", "Need help choosing?"];
  let index = 0;
  let intervalStarted = false;

  function getCurrentText() {
    return texts[index];
  }

  function nextText() {
    index = (index + 1) % texts.length;
    return texts[index];
  }

  function updateTriggerText(shadowRoot, text) {
    const input = shadowRoot.querySelector("#type-bar-input");
    const label = shadowRoot.querySelector('label[for="type-bar-input"]');

    if (input) {
      input.placeholder = text;
    }

    if (label) {
      label.textContent = text;
    }
  }

  function updateIframeText(text) {
    const iframe = document.querySelector("#zipchat-iframe");
    if (!iframe) return;

    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      const textarea = iframeDoc.querySelector('textarea[name="text"]');
      const label = iframeDoc.querySelector('label[for*="message-input"]');

      if (textarea) {
        textarea.placeholder = text;
      }

      if (label) {
        label.textContent = text;
      }
    } catch (error) {
      // Cross-origin iframe — parent page JS cannot access it
      console.warn("Cannot access iframe content because it is cross-origin.");
    }
  }

  function startTextRotation(shadowRoot) {
    if (intervalStarted) return;
    intervalStarted = true;

    const initialText = getCurrentText();
    updateTriggerText(shadowRoot, initialText);
    updateIframeText(initialText);

    setInterval(() => {
      const newText = nextText();
      updateTriggerText(shadowRoot, newText);
      updateIframeText(newText);
    }, 3000);
  }

  function initZipchatShadow() {
    const host = document.querySelector("#zipchat-shadow-host");
    if (!host || !host.shadowRoot) return false;

    const shadowRoot = host.shadowRoot;

    const input = shadowRoot.querySelector("#type-bar-input");
    const label = shadowRoot.querySelector('label[for="type-bar-input"]');

    if (input || label) {
      startTextRotation(shadowRoot);
      return true;
    }

    return false;
  }

  // Try immediately
  if (initZipchatShadow()) return;

  // If not ready yet, observe DOM until widget appears
  const observer = new MutationObserver(() => {
    if (initZipchatShadow()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});